import OrgChart from '../../../components/customer/orgChart/OrgChart'

const CustomerOrgChart = () => {
    return <OrgChart />
}

export default CustomerOrgChart
